import { TextArea } from "@minuthq/meatball-ui-react"
import { useFormik } from "formik"

import { usePostParadiseLLMPromptVersion } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { MDialog } from "src/ui/Dialog/MDialog"

type TParadiseAddLLMPromptVersionForm = {
  description: string
}

const FORM_ID = "add-llm-prompt-version-dialog"

export function ParadiseAddLLMPromptVersionDialog({
  onClose,
  promptId,
  prompt,
}: {
  onClose: () => void
  promptId: string
  prompt: string
}) {
  const form = useFormik<TParadiseAddLLMPromptVersionForm>({
    initialValues: {
      description: "",
    },
    onSubmit: handleSave,
  })

  const postLLMPromptVersion = usePostParadiseLLMPromptVersion()

  async function handleSave() {
    postLLMPromptVersion.mutate(
      {
        path: { prompt_id: promptId },
        body: {
          description: form.values.description,
          prompt: prompt,
        },
      },
      {
        onSuccess: () => {
          onClose()
        },
      }
    )
  }
  return (
    <MDialog
      open={true}
      onClose={onClose}
      title="Add prompt version"
      confirmLabel="Save"
      confirmButtonProps={{
        loading: postLLMPromptVersion.isPending,
      }}
      closeLabel="Cancel"
      closeButtonProps={{
        disabled: postLLMPromptVersion.isPending,
      }}
      formId={FORM_ID}
      width="large"
    >
      <form onSubmit={form.handleSubmit} id={FORM_ID}>
        <TextArea
          label="Description"
          value={form.values.description}
          onChange={(value) =>
            form.setValues((prev) => ({ ...prev, description: value }))
          }
          minRows={3}
          required
        />
      </form>
    </MDialog>
  )
}
